document.addEventListener('DOMContentLoaded',function(){
    // 头部导航
//    $(window).on('scroll', function() {
//         const scrollTop = $(window).scrollTop();
//         const $header = $('sticky-header'); // 建议替换为您具体的类名或 ID

//         if (scrollTop > 20) {
//             $header.addClass('is-scrolled');
//         } else {
//             $header.removeClass('is-scrolled');
//         }
//     });
})